// extracted by mini-css-extract-plugin
export default {"block":"ge","info":"he","error":"ie","noSpace":"je","hideError":"ke"};